import { ReactNode } from 'react';

interface SafeAreaProps {
  children: ReactNode;
  top?: boolean;
  bottom?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function SafeArea({ children, top = true, bottom = false, className = '', style }: SafeAreaProps) {
  return (
    <div
      className={className}
      style={{
        paddingTop: top ? 'var(--ios-safe-top)' : undefined,
        paddingBottom: bottom ? 'var(--ios-safe-bottom)' : undefined,
        ...style
      }}
    >
      {children}
    </div>
  );
}
